import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { CreateVerantwoordelijkeButton } from '../../../projectbetrokkene/components/CreateVerantwoordelijkeButton'
import { Projectbetrokkenen } from '../../../projectbetrokkene/components/Projectbetrokkenen'
import { StyledError } from '../../../theme/components/StyledError'
import { useValuelists } from '../../../valuelists/hooks/useValuelists'
import { useProjectbetrokkenenSearch } from '../hooks/useProjectbetrokkenenSearch'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { ContractinstellingenProjectbetrokkenen }

type Props = {
  filters: ContractinstellingenSearchFilters
}

const ContractinstellingenProjectbetrokkenen = ({ filters }: Props) => {
  const user = useAuthenticatedUser()
  const {
    data: { gebieden },
  } = useValuelists()
  const {
    data: { items: projectbetrokkenen },
    isLoading,
    error,
  } = useProjectbetrokkenenSearch({ externalFilters: filters })

  return (
    <>
      <StyledError error={error} />

      {isLoading && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <CreateVerantwoordelijkeButton
        user={user}
        projectType="Hoofdleiding"
        gebieden={gebieden}
      />

      <Projectbetrokkenen
        user={user}
        projectType="Hoofdleiding"
        projectbetrokkenen={projectbetrokkenen}
      />

      {!isLoading && projectbetrokkenen.length === 0 && (
        <Typography>Selecteer filters om te zoeken.</Typography>
      )}
    </>
  )
}
